module.exports = {"370725001":"宝都街道","370725002":"宝城街道","370725003":"朱刘街道","370725005":"五图街道","370725107":"乔官镇","370725108":"唐吾镇","370725110":"红河镇","370725116":"营丘镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370725.json
// module id = 1307
// module chunks = 0